<template>
<div class="lvChatBox">
<!--  弹窗--选择礼物-->
  <van-popup close-icon="" v-model:show="showFlower" position="bottom">
    <div class="popupBox">
      <div class="badgeIcon">
        <lvIconBadge name="玖瑰" :describe="flower.remainTime" :num="flower.count" :src="require('../../../assets/live/flower.png')" @sendFlower="sendFlower"></lvIconBadge>
      </div>
    </div>
  </van-popup>
<!--  弹窗--便捷发言-->
  <van-popup class="showFast" close-icon="" v-model:show="showFast" position="bottom">
    <div class="FastChatBox">
      <lvChatFast :arrChatFast="arrChatFast" @sendFastContent="sendFastContent"></lvChatFast>
    </div>
  </van-popup>
<!--  底部对话窗口-->
  <div class="lvBottomChatBox" ref="lvBottomChatBox">
    <lvBottomChat ref="lvBottomChatBox2"
                  @chatFlower="chatFlower"
                  @chatFast="chatFast"
                  @sendContent="sendContent"
                  @onFocus="onFocus"></lvBottomChat>
  </div>

<!--  消息列表 :style="{height: chatListHeight}"-->
  <div class="lvChatList" ref="lvChatList">
    <lvChatList ref="lvChatList2" :liveId="baseInfo.id" :isAction="isAction" @altSomeOne="altSomeOne" @updateFlower="updateFlower"></lvChatList>
  </div>
</div>
</template>

<script>
import lvIconBadge from "./lvIconBadge";
import lvBottomChat from "./lvBottomChat";
import lvChatFast from "./lvChatFast";
import lvChatList from "./lvChatList";
import {scroller} from "../../../js/util/scroller";
import {apiLive} from "../../../network/app/apiPlatformLive";
import {wxAuth} from "../../../network/wx/wxAuth";
import {Toast} from "vant";

export default {
  name: "lvChat",
  components:{
    lvIconBadge,
    lvBottomChat,
    lvChatFast,
    lvChatList
  },
  props: {
    isAction: {
      type: Boolean,
      default: false,
    },
    baseInfo: {
      type: Object,
      required: true
    },
  },
  data(){
    return {
      firstAct: true,
      showFlower: false,
      showFast: false,
      arrChatFast: ['科技创新', '科技普及', '同上科普课'],
      chatListHeight: '100px',

      //记录花的信息
      flower: {
        'count': 0,
        'lastUpdateTime': 0,
        'remainTime': '', //大于等于60不显示
      }
    }
  },
  created() {
    console.log("lvchat create ===============")

  },
  mounted() {
  },
  watch:{
    isAction: {
      handler(newVal,oldVal) {
        if((newVal)&&(this.firstAct)){
          this.firstAct = false
          // 第一次激活
          // 获取图文信息
          console.log("第一次激活 聊天室")
          let dt = this.$refs.lvBottomChatBox.offsetTop-this.$refs.lvChatList.offsetTop
          if(dt>0){
            this.chatListHeight = dt + "px"
          }else{
            this.chatListHeight = '10px'
          }
          // console.log(this.chatListHeight)
        }
      },
    }
  },
  methods:{
    updateFlower(obj){
      this.flower = obj
    },
    //显示送花界面
    chatFlower(){
      console.log("father chatFlower")

      //未登录，不允许送花
      if(wxAuth.check(this)){
        this.showFlower = true
      }

    },
    //显示便捷发言
    chatFast(){
      // console.log("father chatFast")
      this.showFast = true
    },
    //发言获取焦点回调
    onFocus(){
      scroller.scrollTo(this.$refs.lvChatList, 0, this.$refs.lvChatList.scrollHeight)
    },

    //输入框发送信息
    sendContent(resObj){
      if(resObj.content==""){
        return
      }
      let obj = {
        'id': this.baseInfo.id,
        'content': resObj.content,
        'commentType': 0,
      }
      if(resObj.altUserId!=0){
        obj.replyId = resObj.altUserId
      }
      this.$refs.lvChatList2.commentLive(obj, this.sendContentCB)
    },
    sendContentCB(status){
      // alert('sendContentCB:'+status)
    },

    //便捷发言--选中词条
    sendFastContent(index){
      console.log("发送便捷发言:"+this.arrChatFast[index])
      this.showFast = false
      let obj = {
        'id': this.baseInfo.id,
        'content': this.arrChatFast[index],
        'commentType': 0,
      }
      this.$refs.lvChatList2.commentLive(obj, this.sendFastContentCB)
    },
    sendFastContentCB(status){
      // alert('sendFastContentCB:'+status)
    },

    //送花
    sendFlower(content){
      this.showFlower = false

      if(this.flower.count==0){
        Toast({
          message: '每1分钟可以获得1个该礼物哦！',
          position: 'bottom',
        });
        return
      }
      let obj = {
        'id': this.baseInfo.id,
        'content': 0,   //用户评论，礼物类型评论 0代表鲜花  (string)
        'commentType': 1,
      }
      this.$refs.lvChatList2.commentLive(obj, this.sendFlowerCB)
    },
    sendFlowerCB(status){
      // alert('sendFlowerCB:'+status)
    },

    altSomeOne(obj){
      this.$refs.lvBottomChatBox2.altSomeOne(obj)
      this.onFocus()
    }
  }
}
</script>

<style scoped>
.lvChatBox{
  position: relative;

}
.popupBox{
  margin: auto;
  margin-top: 60px;
  width: 900px;
  height: 300px;

}
.badgeIcon{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex: 1;
}
.lvBottomChatBox{
  position: fixed;
  bottom: 0px;
  left: 0px;
  width: 100%;
  /*min-height: 100px;*/
  border: none;
  background-color: #f7f7f7;
  border-top: 1px solid #d0d0d0;
  color: whitesmoke;
  font-size: 40px;
  z-index: 3;

  /*background-color: rgba(1.0,1.0,1.0,0.5);*/
}

.showFast{
  background-color: rgba(0,0,0, 0.2);
}
.FastChatBox{
  display: block;
  width: 100%;
  min-height: 400px;
}
.lvChatList{
  /*position: fixed;*/
  width: 990px;
  /*height: 900px;*/
  /*min-height: 900px;*/
  overflow-y: scroll;
  /*background-color: #07c160;*/



  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;

}
.lvChatList::-webkit-scrollbar { width: 0 !important }
.lvChatList { -ms-overflow-style: none; }
.lvChatList { overflow: -moz-scrollbars-none; }

.lvChatList::-webkit-scrollbar {
   display: none;
   width: 0px;
 }
.lvChatList::-webkit-scrollbar {
   display: none;
 }

</style>